import { ChakraProvider } from "@chakra-ui/react";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { store } from "app/store";
import customTheme from "./theme";
import { PATH } from "configs/brandConfig";


  // Providers component to wrap the entire application with necessary providers.
  // It includes:
  // ReduxProvider for state management
  // BrowserRouter for handling routing
  // ChakraProvider for UI styling with a custom theme

const Providers = ({ children }) => {
  return (
    // Provide Redux store to the application
    <ReduxProvider store={store}>
      {/* Enable routing with a specific base path */}
      <BrowserRouter basename={PATH.HOME}>
        {/* Provide Chakra UI theme and global toast configuration */}
        <ChakraProvider
          theme={customTheme}
          toastOptions={{
            defaultOptions: {
              position: "top", // Toast notifications appear at the top
              duration: 1800,
              containerStyle: {
                width: "full", // Full width
                px: "2", // Horizontal padding
                maxWidth: "600px", // Maximum width
              },
            },
          }}
        >
          {children}
        </ChakraProvider>
      </BrowserRouter>
    </ReduxProvider>
  );
};

export default Providers;
